import classNames from "classnames";
import { Menu } from "@design-system/Menu/Menu.lib";
import { markEventBlocked } from "@design-system/ViewTable/ViewTable.lib";
import styles from "./ScheduleCardMenu.module.scss";

interface Props {
    className?: string;
    onEdit?: () => void;
    onViewSchedule?: () => void;
}

/**
 * The schedule card's menu (Figma 9851:22188). The parent shows it while the
 * pill is hovered, and it stays visible while the menu is open. The trigger
 * is a bordered icon button; hovering it darkens that border only.
 */
export function ScheduleCardMenu({ className, onEdit, onViewSchedule }: Props) {
    if (!onEdit && !onViewSchedule) {
        return null;
    }

    return (
        <span
            className={classNames(className, styles.root)}
            onMouseDown={(event) => {
                markEventBlocked(event);
            }}
            onClick={(event) => {
                markEventBlocked(event);
            }}
        >
            <Menu.More
                variant="primary"
                size="md"
                aria-label="Policy actions"
                className={styles.trigger}
                align="start"
            >
                {onEdit ? (
                    <Menu.Item onClick={onEdit}>Edit this schedule</Menu.Item>
                ) : null}
                {onViewSchedule ? (
                    <Menu.Item onClick={onViewSchedule}>
                        View recognition schedule
                    </Menu.Item>
                ) : null}
            </Menu.More>
        </span>
    );
}
